module.exports = Transform;

function Transform() {
  this.x = 0;
  this.y = 0;
  this.scale = 1;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/panzoom/lib/transform.js
// module id = 4061
// module chunks = 0